import PropTypes from 'prop-types'

import { interpolate, useTranslations } from 'common/language'
import { BynderPicture, Container, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


SinglePageHeroView.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
}

export default function SinglePageHeroView({ data }) {
  const { gettext } = useTranslations()
  return (
    <div className={classNames.schoolHero}>
      {
        data.image && (
          <BynderPicture
            image={data.image}
            mobileImage={{
              maxWidth: 1000,
              maxHeight: 411,
              sizes: '100vw',
            }}
            desktopImage={{
              maxWidth: 1920,
              maxHeight: 658,
              sizes: '100vw',
            }}
            priority
          />
        )
      }
      <Container className={classNames.heroContainer} size="xl">
        {(data.title || data.subtitle) && (
          <Typography variant="h1" className={classNames.heroTitle}>
            {data.title + ' '}
            <div className={classNames.schoolGroup}>
              {interpolate(gettext('Sprachschule in %s'), [data.subtitle])}
            </div>
          </Typography>
        )}
      </Container>
    </div>
  )
}
